import { render, staticRenderFns } from "./BmiCalculatorView.vue?vue&type=template&id=552a44ac&"
import script from "./BmiCalculatorView.vue?vue&type=script&lang=js&"
export * from "./BmiCalculatorView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports